function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Notice, isAdmin } from "./shell";
import { getPricingSettings, putPricingSettings } from "../sales/sales-api";

/*
 * Site audience (Manage Data › Products, 2026-10-06; dataflow Products mockup 2026-10-09): who the
 * website is for. Drives the copy on the Demand gaps page and in the digests.
 *
 *   GET/PUT /v1/sales/pricing/settings { siteAudience: "consumer" | "trade" }
 *
 * One card: the question and a one-line hint on the left, two equal radio cards on the right.
 * Picking a card saves it straight away (owners and administrators) and shows "Saved"; a failed save
 * puts the previous choice back. Everyone else reads.
 * Fail-soft: the card is hidden while loading and when the route is absent (404).
 */
const OPTIONS = [["consumer", "Shoppers", "People buy for themselves. Gaps compare how often visitors order online."], ["trade", "Business buyers", "Other businesses browse your site and order through their accounts. Gaps compare business visits with their orders."]];
export default class SiteAudienceCard extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "pick", async value => {
      const {
        settings,
        busy
      } = this.state;
      if (busy || !isAdmin() || !value || value === this.state.value) return;
      const previous = this.state.value;
      this.setState({
        value,
        busy: true,
        saved: false,
        notice: null
      });
      try {
        await putPricingSettings(value);
        if (!this._alive) return;
        this.setState({
          busy: false,
          saved: true,
          settings: {
            ...(settings || {}),
            siteAudience: value
          }
        });
        clearTimeout(this._t);
        this._t = setTimeout(() => {
          if (this._alive) this.setState({
            saved: false
          });
        }, 4000);
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          value: previous,
          notice: {
            tone: "danger",
            text: "Your choice could not be saved. Try again in a moment."
          }
        });
      }
    });
    this.state = {
      settings: undefined,
      value: null,
      busy: false,
      saved: false,
      notice: null
    };
    this._alive = true;
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._t);
  }
  async load() {
    try {
      const settings = await getPricingSettings();
      if (this._alive) this.setState({
        settings,
        value: settings ? settings.siteAudience : null
      });
    } catch (e) {
      if (this._alive) this.setState({
        settings: null
      });
    }
  }
  render() {
    const {
      settings,
      value,
      busy,
      saved,
      notice
    } = this.state;
    if (settings === undefined || settings === null) return null; // loading, or the route has not landed
    const admin = isAdmin();
    let hint = "This sets the wording of Demand gaps and the sales digests.";
    if (!admin) hint += " Owners and administrators change it.";
    return /*#__PURE__*/React.createElement("section", {
      className: "wa-card c12 dl-audience"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dl-audience-intro"
    }, /*#__PURE__*/React.createElement("b", null, "Who is your website for?"), /*#__PURE__*/React.createElement("span", null, hint), !value ? /*#__PURE__*/React.createElement("span", {
      className: "dl-audience-note"
    }, "Not picked yet, so Plunk guesses from your business type.") : null, busy ? /*#__PURE__*/React.createElement("span", {
      className: "dl-audience-note"
    }, "Saving\u2026") : saved ? /*#__PURE__*/React.createElement("span", {
      className: "dl-audience-note ok"
    }, "Saved") : null), OPTIONS.map(([k, label, line]) => {
      const on = value === k;
      return /*#__PURE__*/React.createElement("label", {
        key: k,
        className: `dl-audience-opt${on ? " on" : ""}${!admin ? " ro" : ""}`
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: "site-audience",
        value: k,
        checked: on,
        disabled: !admin || busy,
        onChange: () => this.pick(k)
      }), /*#__PURE__*/React.createElement("span", {
        className: "dl-radio",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("span", {
        className: "dl-audience-text"
      }, /*#__PURE__*/React.createElement("b", null, label), /*#__PURE__*/React.createElement("span", null, line)));
    }), notice ? /*#__PURE__*/React.createElement("div", {
      className: "dl-audience-notice"
    }, /*#__PURE__*/React.createElement(Notice, {
      tone: notice.tone,
      onClose: () => this.setState({
        notice: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "grow"
    }, notice.text))) : null);
  }
}